import React, { useEffect, useState } from "react";
import { useAuth } from "../Auth/useAuth";
import { useCart } from "../Carts/useCart";
import useConfiguration from "../Configuration/useConfiguration";
import useTranslations from "../Translations/useTranslations";
import UiDateInput from "../ui/UiDateInput";
import UiInput from "../ui/UiInput";
import "./ProspectRecap.css";

function ProspectRecap({
  current_cart,
  remise,
  createHeader,
  removeOrderHeader,
  frais_port,
  fildValid,
}) {
  const [{ user }] = useAuth();
  const [carts, cartSDK] = useCart(user.client_profile?.id);
  const { client, header } = current_cart;

  const trl = useTranslations();
  const config = useConfiguration();

  const [formValid, setFormValid] = useState(fildValid);

  const [dateError, setDateError] = useState(null);
  useEffect(() => {
    setFormValid(fildValid);
  }, [fildValid]);
  useEffect(() => {
    const creator = user.client_profile?.id;
    removeOrderHeader({ creator });
    createHeader({ client, remise, frais_port, creator });
    cartSDK.changeHeader("PROSPECT", "O");
    cartSDK.changeHeader("ROLE", "VRP");
    cartSDK.changeHeader("CODVRP", user.id);
  }, []);

  const [formData, setFormData] = useState({
    PROSPECT_EMAIL: header?.PROSPECT_EMAIL || "",
    PROSPECT_ADR_LIV: header?.PROSPECT_ADR_LIV || "",
    PROSPECT_ADR_FACT: header?.PROSPECT_ADR_FACT || "",
    PROSPECT_SIRET: header?.PROSPECT_SIRET || "",
    PROSPECT_TVA: header?.PROSPECT_TVA || "",
    DATE_LIV: header?.DATE_LIV || "",
    REF_CLI: header?.REF_CLI || "",
    COMMENTAIRE_LIBRE: header?.COMMENTAIRE_LIBRE || "",
  });

  const setRefCli = (refcliextension) => {
    cartSDK.changeHeader(
      "REF_CLI",
      `Web ${refcliextension || user?.data?.name || user?.id} ${new Date().getDate()}/${new Date().getMonth()}`,
    );
  };

  useEffect(() => {
    Object.keys(formData).forEach((key) => {
      if (["REF_CLI"].includes(key) && formData[key] && formData[key] !== "") {
        setRefCli(formData.REF_CLI);
        if (key !== "REF_CLI") {
          cartSDK.changeHeader(key, formData[key]);
        }
      } else if (
        key === "DATE_LIV" ||
        (formData[key] && formData[key] !== "")
      ) {
        cartSDK.changeHeader(key, formData[key]);
      }
    });
  }, [formData]);

  const handleChange = (event) => {
    const { name, value } = event;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function deliveryDateChange(e) {
    const targetedDate = e.value;
    const timestr = "" + config.get("dailyOrderLimitTime");
    const todayAtLimit = new Date();

    const hours = parseInt(timestr.substring(0, 2), 10);
    const min = parseInt(timestr.substring(2, 4), 10);
    const sec = parseInt(timestr.substring(4), 10);

    if (timestr) {
      todayAtLimit.setHours(hours, min, sec);
    } else {
      todayAtLimit.setHours(23, 59, 59);
    }
    if (!header?.CODVRP && new Date(targetedDate) < todayAtLimit) {
      let message =
        "Vous ne pouvez pas choisir une date de départ aujourd'hui.";
      if (timestr) {
        message +=
          " L'heure limite pour un départ dans la journée est fixée à " +
          ("" + hours).padStart(2, "0") +
          "h" +
          ("" + min).padStart(2, "0");
      }
      setDateError(message);
      setFormValid((prev) => ({ ...prev, DATE_LIV: true }));
      handleChange({ name: "DATE_LIV", value: null });
    } else {
      setDateError(null);
      setFormValid((prev) => ({ ...prev, DATE_LIV: false }));
      handleChange({ name: "DATE_LIV", value: e.value });
    }
  }

  if (!header) return null;
  return (
    <React.Fragment>
      <div className="prospect-recap-container">
        <div className="prospect-recap-title">
          Les champs sont obligatoires, sauf mention contraire.
        </div>
        <form className="prospect-recap-form">
          <div className="prospect-recap-form-group">
            <label htmlFor="PROSPECT_EMAIL">
              {trl.message("FinishOrderPage.Prospect.emailLabel")}:
            </label>
            <UiInput
              name="PROSPECT_EMAIL"
              type="email"
              onChange={handleChange}
              value={formData.PROSPECT_EMAIL || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.PROSPECT_EMAIL}
              required={true}
            />
          </div>
          <div className="prospect-recap-form-group">
            <label htmlFor="PROSPECT_ADR_LIV">
              {trl.message("FinishOrderPage.Prospect.deliveryAddressLabel")}:
            </label>
            <UiInput
              name="PROSPECT_ADR_LIV"
              onChange={handleChange}
              value={formData.PROSPECT_ADR_LIV || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.PROSPECT_ADR_LIV}
              required={true}
            />
          </div>
          <div className="prospect-recap-form-group">
            <label htmlFor="PROSPECT_ADR_FACT">
              {trl.message("FinishOrderPage.Prospect.billingAddressLabel")}:
            </label>
            <UiInput
              name="PROSPECT_ADR_FACT"
              onChange={handleChange}
              value={formData.PROSPECT_ADR_FACT || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.PROSPECT_ADR_FACT}
              required={true}
            />
          </div>
          <div className="prospect-recap-form-group">
            <label htmlFor="PROSPECT_SIRET">
              {trl.message("FinishOrderPage.Prospect.siretLabel")}:
            </label>
            <UiInput
              name="PROSPECT_SIRET"
              onChange={handleChange}
              value={formData.PROSPECT_SIRET || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.PROSPECT_SIRET}
              required={true}
            />
          </div>
          <div className="prospect-recap-form-group">
            <label htmlFor="PROSPECT_TVA">
              {trl.message("FinishOrderPage.Prospect.tvaLabel")}:
            </label>
            <UiInput
              name="PROSPECT_TVA"
              onChange={handleChange}
              value={formData.PROSPECT_TVA || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.PROSPECT_TVA}
              required={true}
            />
          </div>
          <div className="prospect-recap-form-group">
            <label htmlFor="DATE_LIV">
              {trl.message("FinishOrderPage.Prospect.deliveryDateLabel")}:
            </label>
            <UiDateInput
              name="DATE_LIV"
              value={formData.DATE_LIV}
              onChange={deliveryDateChange}
              errorMessage={dateError}
              throwError={formValid?.DATE_LIV}
              required={true}
            />
          </div>
          {user?.data?.cmd_facultative !== "O" && (
            <div className="prospect-recap-form-group">
              <label htmlFor="REF_CLI">
                Référence commande:
                <br />
                <small>
                  {`Web ${formData.REF_CLI} ${new Date().getDate()}/${new Date().getMonth()}`}
                </small>
              </label>
              <UiInput
                name="REF_CLI"
                onChange={handleChange}
                value={formData.REF_CLI || ""}
                errorMessage="Ce champs est obligatoire"
                throwError={formValid?.REF_CLI}
                required={true}
              />
            </div>
          )}
          <div className="prospect-recap-form-group">
            <label htmlFor="extraInformation">
              {" "}
              {trl.message("FinishOrderPage.Customer.extraInformation")} :
              <br />
              <small>
                {trl.message(
                  "FinishOrderPage.Customer.extraInformationDetails",
                )}
              </small>
            </label>
            <textarea
              onChange={(e) =>
                handleChange({
                  name: "COMMENTAIRE_LIBRE",
                  value: e.target.value,
                })
              }
              style={{
                width: "100%",
                border: "none",
                border: "1px solid rgba(0, 0, 0, .1)",
                borderRadius: 5,
              }}
              rows={5}
            ></textarea>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default ProspectRecap;
